import React from "react";
import "./single-tab.scss";

export interface SingleTabProps {
  id: string;
  label: string;
  tabContent?: (...args: any[]) => any;
  currentActiveTab?: string;
}

export default function SingleTab(props: SingleTabProps) {
  return (
    <>
      <div
        className={
          props.currentActiveTab == props.id
            ? "single-tab-content active"
            : "single-tab-content"
        }
        id={props.id}
        title={props.label}
      >
        {props.label}
      </div>
    </>
  );
}
